import { Component, OnInit } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-worker-reports-menu',
  templateUrl: './worker-reports-menu.component.html',
  styleUrls: ['./worker-reports-menu.component.scss']
})
export class WorkerReportsMenuComponent implements OnInit {


  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {
  }

}
